module.exports = __webpack_public_path__ + "img/eq-helm.add3685c.png";